module.exports = __webpack_public_path__ + "dd3c991c109acb5525b19cf667bb630a.svg";